// removed by extract-text-webpack-plugin
module.exports = {"tick":"ExtraInfo--tick--1p","greenTick":"ExtraInfo--greenTick--eV ExtraInfo--tick--1p","blueTick":"ExtraInfo--blueTick--1t ExtraInfo--tick--1p","orangeTick":"ExtraInfo--orangeTick--1z ExtraInfo--tick--1p","greyTick":"ExtraInfo--greyTick--yY ExtraInfo--tick--1p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExtraInfo/styles.styl
// module id = 842
// module chunks = 0